import { inject, injectable } from 'tsyringe';
import { type IBuyerUserTokenRepository } from 'application/repositorySchemas/IBuyerUserTokenRepository';
import { type IResponseMeetingRequestForBuyerRepository } from 'application/repositorySchemas/IResponseMeetingRequestForBuyerRepository';
import { type IAcceptedRequestMeetingForBuyerClient } from 'interfaceAdapter/gatewaySchemas/IAcceptedRequestMeetingForBuyerClient';
import { type IDeclinedMeetingRequestForBuyerClient } from 'interfaceAdapter/gatewaySchemas/IDeclinedMeetingRequestForBuyerClient';
import { type IBuyerBlockAgentClient } from 'interfaceAdapter/gatewaySchemas/IBuyerBlockAgentClient';

@injectable()
export class ResponseMeetingRequestForBuyerRepository implements IResponseMeetingRequestForBuyerRepository {
    constructor(
        @inject('IBuyerUserTokenRepository')
        public readonly buyerUserToken: IBuyerUserTokenRepository,
        @inject('IAcceptedRequestMeetingForBuyerClient')
        public readonly acceptedRequestMeetingClient: IAcceptedRequestMeetingForBuyerClient,
        @inject('IDeclinedMeetingRequestForBuyerClient')
        public readonly declinedRequestMeetingClient: IDeclinedMeetingRequestForBuyerClient,
        @inject('IBuyerBlockAgentClient')
        public readonly buyerBlockAgentClient: IBuyerBlockAgentClient,
    ) {}

    public async accepted(match_id: number) {
        const { data, message } = await this.acceptedRequestMeetingClient.post({
            token: this.buyerUserToken.get() || '',
            match_id,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }

    public async declined(match_id: number, reason: string) {
        const { data, message } = await this.declinedRequestMeetingClient.post({
            token: this.buyerUserToken.get() || '',
            match_id,
            reason,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }

    public async blockAgent(match_id: number, message: string) {
        const { data, message: errorMessage } = await this.buyerBlockAgentClient.post({
            token: this.buyerUserToken.get() || '',
            match_id,
            message,
        });

        if (errorMessage) {
            throw new Error(errorMessage);
        }

        return data;
    }
}
